import React from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import './gameListCard.css';
import { GameResultEnum, GameStatusForSchedule } from "../components/enum.js";

const ScheduleCard = (props) => {
  const history = useHistory();

  const getStatusText = () => {
    const { gameStatus, gameResult } = props.data;

    if (gameStatus === "forfeit") {
      if (gameResult === GameResultEnum.Won) {
        return { text: "Forfeit 1-0", color: "green", fontWeight: "bold" };
      } else if (gameResult === GameResultEnum.Lost) {
        return { text: "Forfeit 0-1", color: "red", fontWeight: "bold"  };
      }
    }

    switch (gameStatus) {
      case "cancelled":
        return { text: "Cancelled", color: "darkblue" };
      default:
        return { text: "Scheduled", color: "darkblue" };
    }
  };

  const status = getStatusText();

  // const handleNavigation = async () => {
  //   if (props.handleGetAllGames) {
  //     await props.handleGetAllGames(); // Call the function before navigating
  //   }
  
  //   const targetRoute = props.playGame ? "/scheduledgamedetails" : "/editscheduledgame";
    
  //   history.push(targetRoute, {
  //     gameId: props.data._id,
  //   });
  // };

  const handleNavigation = async () => {
   
  

    history.push(`/editscheduledgame/${props.data._id}`);
  };

  return (
    <div
    onClick={handleNavigation}

      className="gameView" 
    >
      <div className="gameLogRow">
        <div>
        <div>
        <span className="greyTxt">
          {props.data.date}&nbsp;&nbsp;{props.data.time}
        </span>
        </div>
        <div>
        <span className="WTxt" style={{ color: status.color }}>
          {status.text}
        </span>
        </div>
        </div>
      </div>
      <span className="vsTxt">
        {props.data.teamB.teamName === props.data.awayTeam ? "VS" : "AT"}
      </span>
      <div>
      <div>
        <p className="teamBname">{props.data.teamB.teamName}</p>
        </div>
        <div>
        <span className="greyTxt">
          {props.data.conference ? "Conference" : "Non-Conference"}
        </span>
      </div>
      </div>
      </div>

  );
};

const GameResultCard = (props) => {
  const history = useHistory();

  return (
    <div
    onClick={async () => {
           await props.handleGetAllGames();
           history.push(`/gamelog/${props.data?._id}`);
         }}
      
      className="gameView"
    >
      <div className="gameLogRow">
        <div>
          <span className="greyTxt">
            {moment(props.data.general.gameDate).format("MM/DD/YYYY, h:mm:ss a").slice(0, 10)}
          </span>
          <div>
            <span
              className="WTxt"
              style={{
                fontWeight:'700',
                color:
                  props.data.teamA.status === "Won"
                    ? "green"
                    : props.data.teamA.status === "Lost"
                    ? "red"
                    : "darkblue",
              }}
            >
              {props.data.teamA.status}
            </span>
            </div>
            <div>
            <span className="goalTxt">
              {props.data.teamA?.goals}-{props.data.teamB?.goals}
            </span>
          </div>
        </div>
      </div>
      <div>
        <span className="vsTxt">
          {props.data.teamA.teamName === props.data.general.homeTeam.teamName ? "VS" : "AT"}
        </span>
      </div>
<div>
      <div>
        <span className="teamBname">{props.data.teamB.teamName}</span>
        </div>
        <div>
        <span className="greyTxt">
          {props.data.general.conference ? "Conference Game" : "Non-Conference"}
        </span>
      </div>
      </div>
    </div>
  );
};

const CardComponent = (props) => {
  if (props.data.gameStatus === "completed") {
    return <GameResultCard {...props} />;
  } else if (props.data.gameStatus === "scheduled" || props.data.gameStatus === "forfeit") {
    return <ScheduleCard {...props} />;
  }
};

export default CardComponent;
